import MotionHoc from "./MotionHoc";

const TeamComponent = () => {
  return <h1>Team</h1>;
};

const Team = MotionHoc(TeamComponent);

export default Team;
